import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient } from '@benzinga/session';
import { Session } from '@benzinga/session';
import { MarketingWinsEnvironment } from './environment';
import { MarketingEgressWinRequestParams } from './egress';
import { IngressMarketingWinsResponse } from './ingress';

export class MarketingWinsRestful extends RestfulClient {
  private spaceId;
  private environmentId;
  private apiKey;

  constructor(session: Session) {
    super(session.getEnvironment(MarketingWinsEnvironment).url, session, undefined, {
      tokenParameterName: 'accessToken',
    });
    this.spaceId = session.getEnvironment(MarketingWinsEnvironment).space;
    this.environmentId = session.getEnvironment(MarketingWinsEnvironment).environment;
    this.apiKey = session.getEnvironment(MarketingWinsEnvironment).apiKey;
  }

  getWins = (params: MarketingEgressWinRequestParams): SafePromise<IngressMarketingWinsResponse> => {
    const url = this.URL(`spaces/${this.spaceId}/environments/${this.environmentId}/entries`, {
      ...params,
      content_type: 'winsDailyTrades',
    });
    return this.debouncedGet(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
      headers: {
        Authorization: `Bearer ${this.apiKey}`,
      },
    });
  };
}
